// extracted by mini-css-extract-plugin
module.exports = {"container":"r_c","menu":"r_R","active":"r_S"};